import React from 'react';
import styled from '@emotion/styled/macro';
import { TRANSPARENT_GREY } from '../constants/_colors';
import Loader from './Loader';

const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${TRANSPARENT_GREY};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CenteredLoader = () => {
  return (
    <LoaderWrapper>
      <Loader />
    </LoaderWrapper>
  );
};

export default CenteredLoader;
